import { t } from "@/i18n";
import { useState } from "react";
import { ChevronDown, Lightbulb, HelpCircle } from "lucide-react";
import { Quiz } from "@/components/Quiz";

export const FactsPanel = ({ page }) => {
  const [showQuiz, setShowQuiz] = useState(false);
  if (!page.facts?.length && !page.quiz?.length) return null;
  return (
    <div className="space-y-4" data-testid="facts-panel">
      {page.facts?.length > 0 && (
        <div className="bg-white rounded-2xl p-5 border-2 border-amber-200">
          <div className="flex items-center gap-2 mb-3">
            <Lightbulb className="w-5 h-5 text-[#FF9F43]" />
            <h4 className="font-display font-semibold text-lg">{t("fun_facts")}</h4>
          </div>
          <ul className="space-y-2">
            {page.facts.map((f, i) => (
              <li key={f} className="flex gap-3 text-sm sm:text-base" data-testid={`fun-fact-${i}`}>
                <span className="w-6 h-6 shrink-0 rounded-full bg-[#FFD166] text-xs font-bold flex items-center justify-center">{i + 1}</span>
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {page.quiz?.length > 0 && (
        <div className="bg-white rounded-2xl border-2 border-teal-200 overflow-hidden">
          <button
            data-testid="toggle-quiz-preview"
            onClick={() => setShowQuiz((s) => !s)}
            className="w-full flex items-center justify-between p-5 hover:bg-teal-50 transition-colors"
          >
            <span className="flex items-center gap-2 font-display font-semibold text-lg">
              <HelpCircle className="w-5 h-5 text-[#4ECDC4]" /> Mini quiz ({page.quiz.length}) <span className="text-sm font-sans font-normal text-slate-500">{t("tap_an_answer")}</span>
            </span>
            <ChevronDown className={`w-5 h-5 transition-transform ${showQuiz ? "rotate-180" : ""}`} />
          </button>
          {showQuiz && <div className="px-5 pb-5"><Quiz questions={page.quiz} /></div>}
        </div>
      )}
    </div>
  );
};
